import { RegionCode } from '@aviv-estimation-funnel/estimation-data-models/enums';
import libphonenumber from 'google-libphonenumber';

export class PhoneNumber {
    public static readonly PHONE_NUMBER_UTIL = libphonenumber.PhoneNumberUtil.getInstance();

    public readonly e164: string;
    public readonly international: string;
    public readonly regionCode?: string;

    private readonly parsedPhoneNumber: libphonenumber.PhoneNumber;

    constructor(phoneNumberRaw: string, expectedCountryCode: RegionCode) {
        this.parsedPhoneNumber = PhoneNumber.PHONE_NUMBER_UTIL.parse(
            phoneNumberRaw,
            expectedCountryCode,
        );
        this.e164 = PhoneNumber.PHONE_NUMBER_UTIL.format(
            this.parsedPhoneNumber,
            libphonenumber.PhoneNumberFormat.E164,
        );
        this.international = PhoneNumber.PHONE_NUMBER_UTIL.format(
            this.parsedPhoneNumber,
            libphonenumber.PhoneNumberFormat.INTERNATIONAL,
        );

        this.regionCode = PhoneNumber.PHONE_NUMBER_UTIL.getRegionCodeForNumber(
            this.parsedPhoneNumber,
        );
    }

    isValidNumber(): boolean {
        return PhoneNumber.PHONE_NUMBER_UTIL.isValidNumber(this.parsedPhoneNumber);
    }

    isMobileNumber(): boolean {
        const numberType = PhoneNumber.PHONE_NUMBER_UTIL.getNumberType(this.parsedPhoneNumber);
        return (
            numberType === libphonenumber.PhoneNumberType.MOBILE ||
            // In some regions (e.g. the USA), it is impossible to distinguish between
            // fixed-line and mobile numbers by looking at the phone number itself.
            numberType === libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE
        );
    }

    isFixedLineNumber(): boolean {
        const numberType = PhoneNumber.PHONE_NUMBER_UTIL.getNumberType(this.parsedPhoneNumber);
        return (
            numberType === libphonenumber.PhoneNumberType.FIXED_LINE ||
            numberType === libphonenumber.PhoneNumberType.VOIP ||
            // In some regions (e.g. the USA), it is impossible to distinguish between
            // fixed-line and mobile numbers by looking at the phone number itself.
            numberType === libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE
        );
    }
}
